export default {
  container: 'notification-center-container',
};
